<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
export default {
  data () {
    return {
      cdata: {
        xData: ['劳务合同', '专业分包', '材料采购', '设计/咨询'],
        seriesData: [
          { value: 52, name: '劳务合同' },
          { value: 7, name: '专业分包' },
          { value: 171, name: '材料采购' },
          { value: 19, name: '设计/咨询' }
        ]
      }
    }
  },
  components: {
    Chart,
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
